<template>
  <div class="imgProof" v-show="!formItemInfo.needHide">
    <header class="proof-title">
      {{formItemInfo.name}}
    </header>
    <div class="proof-desc">
      {{formItemInfo.desc}}
    </div>
    <z-upload
      ref="upload"
      v-model="files"
      accept="image/*"
      :capture="formItemInfo.isCapture"
      :max="maxImgCount"
      :process-file="processFile"
      @file-success="fileSuccess"
      @file-error="fileError"
      @file-removed="fileDelete"
      weixin
    >
      <div class="custom-upload">
        <z-upload-file
          v-for="(file, index) in files"
          :file="file"
          :key="index"
        />
        <z-upload-btn v-if="showBtn">
          <i>＋</i>
        </z-upload-btn>
      </div>
    </z-upload>
  </div>
</template>

<script>
import Vue from 'vue'
import { Upload, Dialog } from '@zz-common/zz-ui'
import compress from '@zz-common/zz-ui/lib/utils/image'
import { getRuleValue, showRuleTips } from '../utils'

Vue.use(Dialog)

export default {
  name: 'ImgProof',
  data() {
    return {
      files: []
    }
  },
  props: {
    formItemInfo: {
      type: Object,
      require: true
    }
  },
  computed: {
    isRequired() {
      const { rules } = this.formItemInfo
      return Boolean(Number(getRuleValue(rules, 'isRequire')))
    },
    maxImgCount() {
      const { rules } = this.formItemInfo
      return Number(getRuleValue(rules, 'maxImgCount')) || 6
    },
    showBtn() {
      return this.maxImgCount > this.files.length;
    }
  },
  methods: {
    customValidate() {
      // 根据后端返回的规则,校验用户当前的输入内容是否符合要求
      let validation = true
      if (this.isRequired && this.files.length === 0) {
        showRuleTips(this.formItemInfo.rules, 'isRequire')
        validation = false
      } else if (!this.$refs.upload.isComplete()) {
        Dialog.alert({ message: '还有部分凭证信息未上传完成，请稍后再试' })
        validation = false
      }
      return validation
    },
    processFile(file, next) {
      // 开启图片压缩，提高上传的速度，同时修正拍摄的图片方向和显示的问题
      compress(file, {
        compress: true
      }, next)
    },
    onSubmitImgs() {
      const { name, type } = this.formItemInfo
      const newVals = this.files.map(el => el.url)
      console.log('onSubmit', newVals)
      this.$emit('onSubmit', { name, type, value: newVals })
    },
    fileSuccess(file) {
      console.log('success', file)
      this.onSubmitImgs()
    },
    fileError(file) {
      console.log('error', file)
    },
    fileDelete(_file) {
      this.$nextTick(() => {
        this.onSubmitImgs()
      })
    }
  },
  components: {
    zUpload: Upload,
    zUploadBtn: Upload.Btn,
    zUploadFile: Upload.File
  }
}

</script>
<style lang="less" scoped>
  @import 'index.less';
</style>